import { useEffect, useRef, useState } from "react";

interface TypewriterProps {
  lines: { text: string; className?: string; style?: React.CSSProperties }[];
  startDelay?: number;
  charDelay?: number;
  lineDelay?: number;
}

export function Typewriter({
  lines,
  startDelay = 600,
  charDelay = 45,
  lineDelay = 300,
}: TypewriterProps) {
  const [displayed, setDisplayed] = useState<string[]>(lines.map(() => ""));
  const [done, setDone] = useState(false);
  const rafRef = useRef<number | null>(null);

  useEffect(() => {
    let cancelled = false;

    const animate = async () => {
      await delay(startDelay);

      for (let li = 0; li < lines.length; li++) {
        const full = lines[li].text;
        for (let ci = 0; ci <= full.length; ci++) {
          if (cancelled) return;
          setDisplayed((prev) => {
            const next = [...prev];
            next[li] = full.slice(0, ci);
            return next;
          });
          await delay(charDelay);
        }
        if (li < lines.length - 1) await delay(lineDelay);
      }
      if (!cancelled) setDone(true);
    };

    animate();
    return () => {
      cancelled = true;
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, []);

  return (
    <>
      {lines.map((line, i) => (
        <span key={i} className={line.className} style={line.style}>
          {displayed[i]}
          {/* カーソル: 最後の行が打ち終わるまで点滅 */}
          {i === lines.length - 1 && !done && (
            <span className="inline-block w-[2px] h-[1em] ml-[2px] align-middle bg-current animate-pulse" />
          )}
        </span>
      ))}
    </>
  );
}

function delay(ms: number) {
  return new Promise<void>((resolve) => setTimeout(resolve, ms));
}
